module.exports = function() {
  return new Worker(__webpack_public_path__ + "a5ee2efd3e4d1582948f.worker.js");
};